<template>
    <div class="login">
        <div class="login__inner">
            <div class="login__header">
                <logo></logo>
                <switcher></switcher>
            </div>
            <div class="login__body">
                <div class="login__title">
                    {{ $t('auth.sign_in_title') }}
                </div>
                 <!--BEGIN FORM-->
                <loginForm></loginForm>
                 <!--END FORM-->
            </div>
            <div class="login__footer">
                <loginFaq></loginFaq>
            </div>
        </div>
    </div>
</template>



<script>
    import switcher from '@/elements/switcher.vue'
    import logo from '@/elements/logo.vue'
    import loginForm from './loginForm.vue'
    import loginFaq from './loginFaq.vue'
    export default {
        components: {
            switcher,
            logo,
            loginForm,
            loginFaq
        }

    }
</script>

<style lang="sass" scoped>
    .login
        width: 50%
        &__inner
            padding: 37px 26.24795% 46px 18.281073%
            height: 100%
        &__header
            display: flex
            justify-content: space-between
            align-items: center
        &__body
            flex: 1
            border-bottom: 1px solid #D7DDE1
            padding: 22.665625% 0 14.865625% 0
            margin-bottom: 54px
        &__footer
            flex-shrink: 0
        &__title
            font-size: 36px
            color: $color--dark
            +bold

</style>